const FileUpIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58579 1.25241C2.96086 0.87734 3.46957 0.666626 4 0.666626H9.66667C9.84348 0.666626 10.013 0.736864 10.1381 0.861888L13.8047 4.52855C13.9298 4.65358 14 4.82315 14 4.99996V13.3333C14 13.8637 13.7893 14.3724 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H4C3.46957 15.3333 2.96086 15.1226 2.58579 14.7475C2.21071 14.3724 2 13.8637 2 13.3333V2.66663C2 2.13619 2.21071 1.62749 2.58579 1.25241ZM12.0572 4.66663L10 2.60943V4.66663H12.0572ZM8.66667 1.99996V5.33329C8.66667 5.70148 8.96514 5.99996 9.33333 5.99996H12.6667V13.3333C12.6667 13.5101 12.5964 13.6797 12.4714 13.8047C12.3464 13.9297 12.1768 14 12 14H4C3.82319 14 3.65362 13.9297 3.5286 13.8047C3.40357 13.6797 3.33333 13.5101 3.33333 13.3333V2.66663C3.33333 2.48981 3.40357 2.32025 3.5286 2.19522C3.65362 2.0702 3.82319 1.99996 4 1.99996H8.66667ZM7.5286 7.52855C7.78895 7.2682 8.21106 7.2682 8.4714 7.52855L10.4714 9.52855C10.7318 9.7889 10.7318 10.211 10.4714 10.4714C10.2111 10.7317 9.78895 10.7317 9.5286 10.4714L8.66667 9.60943V12C8.66667 12.3681 8.36819 12.6666 8 12.6666C7.63181 12.6666 7.33333 12.3681 7.33333 12V9.60943L6.4714 10.4714C6.21106 10.7317 5.78894 10.7317 5.5286 10.4714C5.26825 10.211 5.26825 9.7889 5.5286 9.52855L7.5286 7.52855Z"
        fill="#08172b"
      />
    </svg>
  );
};

export default FileUpIcon;
